import { createI18n } from "vue-i18n";
import enUS from "@/app/locale/en-US";

const messages = {
  "en-US": { ...enUS },
};

const options = {
  locale: "en-US", // set locale
  messages: messages, // set locale messages
  silentFallbackWarn: true,
  globalInjection: true,
};

// Create VueI18n instance with options
export default createI18n(options);
